module.exports = __webpack_public_path__ + "img/bs-3.752a26ca.jpg";